/**
 * Smooth House Icon Component
 * Custom brush-style house icon with smooth curves
 */

import React from 'react';

interface SmoothHouseIconProps {
  size?: number;
  className?: string;
}

export const SmoothHouseIcon: React.FC<SmoothHouseIconProps> = ({
  size,
  className
}) => {
  return (
    <svg
      width={size ?? '100%'}
      height={size ?? '100%'}
      viewBox="200 175 613 613"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">
        <path d="M5000 8019 c-72 -35 -103 -56 -210 -148 -169 -144 -222 -192 -374
-341 -88 -85 -176 -171 -196 -190 -21 -19 -66 -62 -101 -96 -35 -34 -86 -80
-114 -104 -57 -49 -114 -100 -378 -336 -104 -93 -205 -182 -226 -199 -20 -16
-46 -39 -57 -50 -12 -11 -46 -39 -75 -62 -30 -24 -129 -102 -221 -175 -91 -73
-181 -144 -199 -158 -18 -14 -47 -37 -64 -51 -43 -38 -268 -207 -345 -259
-104 -72 -221 -168 -209 -172 6 -2 -11 -15 -37 -28 -27 -13 -63 -34 -80 -46
-17 -13 -35 -20 -39 -16 -5 4 -5 1 -1 -5 5 -9 0 -13 -14 -13 -12 0 -19 -4 -16
-9 3 -5 -8 -14 -24 -21 -16 -7 -35 -20 -42 -29 -12 -15 -11 -15 7 -1 19 14 19
14 6 -2 -7 -10 -22 -18 -32 -18 -10 0 -24 -9 -31 -19 -6 -10 -17 -17 -24 -14
-8 3 -11 -2 -7 -16 4 -16 1 -21 -13 -21 -9 0 -15 -3 -11 -6 11 -11 137 19 212
51 50 22 165 49 165 39 0 -3 -10 -8 -22 -13 -13 -5 -23 -17 -23 -27 0 -18 -14
-27 -125 -79 -55 -25 -55 -25 1 -21 31 3 67 10 81 15 14 5 28 7 31 5 3 -3 15
0 27 6 13 7 34 14 49 16 53 9 60 11 146 45 28 10 58 19 68 19 9 0 17 5 17 10
0 6 7 10 15 10 8 0 38 11 67 24 29 13 83 37 119 54 36 16 126 65 200 109 190
113 181 109 175 81 -11 -50 -18 -96 -21 -153 -2 -33 -7 -112 -11 -175 -12
-194 -5 -872 11 -1030 2 -25 7 -90 10 -145 14 -242 17 -276 35 -345 5 -19 12
-66 15 -105 3 -38 7 -77 9 -85 1 -8 6 -36 10 -62 17 -98 24 -41 26 190 1 130
3 260 5 287 1 28 3 101 4 163 1 64 6 112 11 112 6 0 10 -21 10 -48 0 -26 5
-85 10 -130 6 -45 13 -104 15 -130 5 -55 18 -164 21 -174 1 -5 2 -22 3 -39 0
-17 5 -28 11 -24 6 3 7 17 4 31 -5 18 -2 24 11 24 10 0 15 5 12 13 -3 8 -1 20
4 28 6 10 9 2 9 -25 0 -27 -4 -37 -13 -33 -13 5 -4 -169 9 -182 3 -3 5 15 3
41 -2 27 -1 49 3 50 4 2 9 39 13 83 18 248 19 252 39 410 36 288 39 928 4
1165 -5 41 -10 86 -10 100 0 47 -36 196 -63 255 -30 69 -47 47 134 177 63 45
123 92 134 105 11 12 24 23 29 23 4 0 18 9 30 19 13 11 52 42 88 70 36 28 72
56 80 64 111 101 228 203 280 246 156 128 656 619 835 821 205 230 177 209
216 165 19 -21 51 -57 72 -79 21 -21 52 -58 69 -80 18 -23 39 -48 47 -57 9 -9
50 -54 91 -100 219 -243 317 -346 550 -578 140 -140 323 -313 405 -383 83 -71
179 -155 215 -187 108 -95 299 -244 415 -325 61 -41 116 -80 123 -86 7 -6 16
-9 20 -6 5 3 15 -4 22 -15 8 -10 22 -19 31 -19 9 0 33 -11 53 -25 44 -30 54
-32 29 -7 -17 17 -158 102 -170 102 -3 0 -17 12 -32 28 -25 26 -74 67 -116 97
-135 99 -175 130 -175 139 0 6 -13 18 -29 26 -31 16 -89 65 -235 198 -50 45
-98 89 -106 96 -8 7 -44 43 -79 80 -35 36 -67 66 -71 66 -11 0 -72 81 -66 88
4 3 41 -28 84 -70 42 -41 102 -97 132 -124 30 -27 79 -72 108 -101 30 -28 74
-69 100 -90 48 -40 119 -102 162 -141 14 -13 54 -45 90 -70 36 -26 74 -54 85
-64 11 -9 49 -39 85 -66 36 -28 72 -56 81 -64 9 -7 22 -14 29 -16 8 -2 30 -16
49 -31 20 -15 55 -39 79 -53 23 -13 39 -28 35 -31 -3 -4 0 -7 7 -7 7 0 50 -22
95 -49 88 -54 221 -120 245 -124 8 -2 20 -5 25 -8 9 -5 46 -17 80 -24 6 -2 30
-8 55 -15 25 -7 50 -13 55 -15 6 -1 22 -7 36 -13 14 -5 43 -9 65 -8 25 1 44
-4 52 -14 9 -10 11 -11 6 -1 -6 11 -3 13 12 6 19 -8 46 -12 134 -20 25 -2 45
-4 45 -5 0 -1 17 -3 38 -6 50 -6 47 3 -5 17 -23 6 -53 19 -66 30 -14 10 -31
19 -38 19 -8 0 -14 5 -14 10 0 6 -6 10 -14 10 -19 0 -144 67 -178 95 -15 13
-53 38 -85 56 -32 18 -70 42 -85 53 -59 47 -74 57 -140 98 -91 57 -283 192
-312 220 -13 13 -59 52 -102 88 -211 173 -294 244 -294 254 0 5 12 -2 28 -16
15 -14 46 -38 70 -53 23 -15 42 -32 42 -36 0 -5 6 -9 14 -9 7 0 19 -7 26 -15
11 -14 66 -45 79 -45 3 0 -8 12 -24 28 -16 15 -33 27 -38 27 -4 0 -11 5 -15
10 -4 6 -50 49 -103 96 -143 126 -342 313 -442 415 -48 49 -95 96 -104 104 -9
8 -46 46 -82 85 -36 38 -95 98 -130 132 -36 35 -61 63 -58 63 9 0 8 1 248
-234 227 -222 457 -435 469 -436 3 0 26 -18 50 -41 25 -23 77 -66 115 -97 39
-30 86 -70 105 -88 56 -52 358 -259 366 -251 2 2 -37 35 -88 73 -112 83 -171
131 -252 205 -33 31 -97 87 -141 125 -43 38 -313 303 -600 590 -625 626 -716
720 -855 884 -232 276 -416 367 -580 289z m708 -1072 c9 -7 33 -30 52 -52 19
-21 28 -34 19 -27 -9 6 -18 9 -21 6 -6 -5 -98 98 -98 110 0 4 7 0 15 -8 9 -9
24 -21 33 -29z m122 -123 c0 -8 4 -14 9 -14 10 0 57 -44 91 -85 19 -23 20 -26
4 -12 -11 9 -23 15 -26 12 -8 -8 -95 91 -101 115 -4 17 -3 19 9 9 8 -6 14 -18
14 -25z m264 -255 c52 -55 67 -79 49 -79 -5 0 -19 16 -32 35 -13 19 -29 35
-35 35 -6 0 -35 25 -65 54 -53 55 -53 55 -13 35 22 -11 65 -47 96 -80z m-3483
-643 c-12 -14 -132 -96 -221 -151 -88 -53 -12 7 106 84 129 86 132 88 115 67z"/>
        <path d="M4745 5570 c-167 -10 -312 -104 -362 -236 -34 -88 -36 -732 -3 -819
5 -14 10 -37 10 -49 0 -24 57 -146 68 -146 4 0 18 -10 32 -23 42 -38 74 -54
120 -62 25 -4 50 -11 55 -15 56 -45 859 46 960 108 11 7 23 10 68 19 33 6 36
23 5 24 -13 1 -27 2 -33 4 -5 1 -73 3 -149 3 -77 1 -136 5 -132 10 10 10 3 9
212 11 102 0 183 5 180 9 -3 5 36 14 85 21 99 14 107 19 39 22 -49 3 -124 31
-113 43 4 3 8 35 10 69 2 34 6 82 9 107 7 54 7 27 -1 305 -10 361 -11 385 -23
397 -7 7 -12 22 -12 33 0 12 -8 30 -18 41 -9 10 -25 31 -34 45 -19 30 -69 56
-119 63 -19 3 -65 9 -104 15 -73 10 -578 11 -750 1z m738 -700 c-2 -140 -4
-275 -6 -300 -2 -45 -2 -45 -252 -46 -137 0 -295 -4 -350 -8 -55 -4 -107 -8
-115 -8 -54 -4 -55 0 -65 182 -4 63 -10 171 -14 240 -4 69 -7 171 -7 228 1
115 -59 103 549 117 120 2 226 9 235 14 24 13 30 -89 25 -419z"/>
        <path d="M6990 5502 c-35 -16 -60 -38 -60 -53 0 -8 -16 -33 -36 -55 -77 -85
-102 -216 -109 -569 -5 -280 -12 -472 -19 -542 -3 -27 -10 -97 -16 -158 -6
-60 -13 -123 -16 -139 -4 -16 -7 -40 -9 -55 -2 -14 -6 -37 -9 -51 -3 -14 -8
-37 -11 -53 -9 -50 -37 -120 -61 -156 -13 -20 -35 -52 -48 -72 -64 -95 -324
-127 -726 -90 -69 6 -172 13 -230 16 -58 3 -127 8 -155 10 -52 5 -196 13 -326
19 -43 2 -82 7 -88 10 -6 4 -11 4 -11 -1 0 -4 -174 -8 -388 -8 -213 1 -391 -2
-397 -4 -5 -3 -28 -6 -50 -7 -43 -2 -175 -11 -265 -19 -30 -3 -84 -8 -120 -10
-36 -3 -132 -18 -215 -32 -82 -14 -159 -27 -170 -28 -11 -1 -27 -5 -35 -7 -8
-3 -55 -16 -105 -28 -175 -45 -300 -78 -320 -85 -182 -67 -436 -185 -475 -220
-8 -7 -28 -19 -44 -25 -16 -6 -26 -13 -22 -17 3 -3 37 10 75 30 39 20 114 50
168 66 54 16 138 41 188 56 116 35 308 75 349 74 21 -1 13 -4 -24 -10 -315
-51 -720 -226 -924 -399 -83 -71 -117 -114 -56 -70 49 35 232 118 332 151 51
16 102 34 113 39 24 10 271 69 312 74 15 2 46 8 68 14 22 5 47 10 55 10 8 0
26 3 40 6 87 20 251 49 290 51 28 2 149 13 225 22 134 14 978 24 1110 13 50
-5 133 -12 185 -15 52 -4 98 -9 102 -11 3 -2 41 -7 85 -10 43 -3 81 -8 84 -10
3 -1 32 -6 65 -9 32 -3 79 -10 104 -15 25 -6 92 -17 150 -25 58 -8 128 -19
155 -24 28 -5 68 -13 90 -16 22 -4 44 -9 49 -12 4 -3 40 -7 80 -10 39 -2 125
-10 191 -17 192 -20 448 -11 585 23 81 19 250 104 297 149 21 20 56 52 78 71
22 19 45 46 52 59 7 13 24 45 37 71 26 51 51 159 61 266 22 228 25 266 31 465
5 156 8 465 4 465 0 0 -2 41 -5 90 -17 371 -20 404 -52 580 -18 103 -46 172
-74 180 -10 4 -19 10 -19 15 0 26 -88 57 -120 42z m-3490 -2168 c-115 -16
-115 -16 -106 -7 9 9 89 20 151 21 37 0 24 -4 -45 -14z"/>
      </g>
    </svg>
  );
};
